import {Component, inject} from '@angular/core';
import {AuthService} from "../../../core/api-services/auth.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-permission-denied',
  imports: [],
  templateUrl: './permission-denied.component.html',
  styleUrl: './permission-denied.component.scss'
})
export class PermissionDeniedComponent {
  authService = inject(AuthService);
  router = inject(Router);

  navigateToFirstList() {
    const permissions = this.authService.permissions();
    if (!permissions) return;

    const targetEntity =
      Object.entries(permissions).find(([_, actions]) => actions.includes('list'))?.[0];

    void this.router.navigate([`/dashboard/list/${targetEntity ?? ''}`]);
  }
}
